import Axios from "axios";
import store from "../store/index";

const RESOURCE_NAME = "bridgePortal";
export default {
  getPortalConfiguration() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return Axios.get(RESOURCE_NAME + "/getPortalConfiguration");
  },
  login(data) {
    Axios.defaults.headers = { "Content-Type": "application/json" };
    return Axios.post(RESOURCE_NAME + "/Login", data);
  },
  loginOtp(data) {
    Axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.post(RESOURCE_NAME + "/LoginOtp", data);
  },

  getEmployeeInformations() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(RESOURCE_NAME + "/GetEmployeeInformations");
  },
  getEmployeeAdAccounts() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(RESOURCE_NAME + "/getEmployeeAdAccounts");
  },
  getEmployeeLocalAccounts() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(RESOURCE_NAME + "/getEmployeeLocalAccounts");
  },
  getEmployeeLocalAccountPassword(username) {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(
      RESOURCE_NAME + "/GetEmployeeLocalAccountPassword/" + username
    );
  },
  getEmployeeAccountsOtp() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(RESOURCE_NAME + "/getEmployeeAccountsOtp");
  },
  getEmployeeCommitments() {
    Axios.defaults.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + store.state.jwt,
    };
    return Axios.get(RESOURCE_NAME + "/GetEmployeeCommitments");
  },
};
